import { types, actions } from './requests'
export const DELETEDEPOSIT_TYPES = {
    ...types('DELETEDEPOSIT'),
}
export const DELETEDEPOSIT_ACTIONS = {
    ...actions('DELETEDEPOSIT'),
}
